import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Manrope', -apple-system, BlinkMacSystemFont, sans-serif;
    background-color: ${theme.colors.bg};
    color: ${theme.colors.text};
    line-height: 1.6;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;

    
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Space Grotesk', 'Manrope', sans-serif;
    font-weight: 700;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul {
    list-style: none;
  }

  img {
    max-width: 100%;
    display: block;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: 'Space Grotesk', 'Manrope', sans-serif;
  }

  input, textarea, select {
    font-family: 'Manrope', sans-serif;
    outline: none;
  }

  section {
    padding: 100px 0;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.bg};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gradient};
    border-radius: 3px;
  }

  ::selection {
    background: rgba(${theme.colors.primaryRgb}, 0.28);
    color: ${theme.colors.text};
  }
`;

export default GlobalStyle;
